export const ACTION_TYPES = {
  START: "START",
  STOP: "STOP",
};
